import { useEffect } from 'react'

export const useRefetchOnFocus = (refetch?: () => Promise<unknown>) => {
  useEffect(() => {
    if (!refetch) return

    const handleFocus = () => {
      refetch().catch((e) => console.error({ refetchOnFocusError: e }))
    }

    window.addEventListener('focus', handleFocus)
    return () => window.removeEventListener('focus', handleFocus)
  }, [refetch])
}
